// eslint-disable-next-line import/no-anonymous-default-export
export default {
  USER_PORTAL_READ: 'spn_system_userportal_read',
  USER_PORTAL_SURETY_CREATE: 'spn_system_userportal_surety_create',
  USER_PORTAL_SIMPLICITY_CREATE: 'spn_system_userportal_simplicity_create',
  USER_PORTAL_FIDELITY_CREATE: 'spn_system_userportal_fidelity_create',
  JADE_API_WRITE_SPN_ENVELOPES: 'jade_api_esign_write_spn_envelopes',
  JADE_API_READ_SPN_ENVELOPES: 'jade_api_esign_read_spn_envelopes',
  JADE_API_WRITE_AVALIS_ENVELOPES: 'jade_api_esign_write_avalis_envelopes',
  JADE_API_READ_AVALIS_ENVELOPES: 'jade_api_esign_read_avalis_envelopes'
};
